module.exports = __webpack_public_path__ + "static/media/Seam_6920.1928ad77.jpg";